(() => {
  const activeSearchSelectors = [
    '.new-design-search-modal__bar',
    '.new-design-search-start',
    '.predictive-search--header',
  ].join(', ');

  const initSearch = (search) => {
    if (search.dataset.outsideCloseInitialized) return;
    search.dataset.outsideCloseInitialized = 'true';

    const details = search.querySelector('details');
    const modal = search.querySelector('.new-design-search-modal');
    if (!details || !modal) return;

    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const openImmediately = search.open?.bind(search);
    if (openImmediately) {
      search.open = (event) => {
        openImmediately(event);

        // Keep the desktop scrollbar in place. The overlay below intercepts
        // scroll input, so the background cannot move without changing layout
        // width or creating a reserved gutter at the edge of the page.
        if (isDesktop()) document.body.classList.remove('overflow-hidden');
      };
    }

    const closeImmediately = search.close?.bind(search);
    if (closeImmediately) {
      search.close = (focusToggle = true) => {
        const shouldAnimate =
          details.open &&
          window.matchMedia('(min-width: 990px)').matches &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!shouldAnimate || search.dataset.searchClosing) {
          if (!search.dataset.searchClosing) {
            closeImmediately(focusToggle);
          }
          return;
        }

        search.dataset.searchClosing = 'true';
        search.classList.add('is-closing');

        // Keep this in sync with the is-closing CSS transition duration so the
        // panel doesn't vanish before/after the animation. Fast close ≈ open.
        window.setTimeout(() => {
          search.classList.remove('is-closing');
          delete search.dataset.searchClosing;
          closeImmediately(focusToggle);
        }, 150);
      };
    }

    modal.addEventListener(
      'wheel',
      (event) => {
        if (!details.open || !isDesktop()) return;

        const scrollArea = event.target.closest('.predictive-search--header');
        const canScrollWithinResults =
          scrollArea &&
          ((event.deltaY < 0 && scrollArea.scrollTop > 0) ||
            (event.deltaY > 0 && scrollArea.scrollTop + scrollArea.clientHeight < scrollArea.scrollHeight));

        if (!canScrollWithinResults) event.preventDefault();
      },
      { passive: false }
    );

    // DetailsModal attaches its native close handler to this button during
    // construction. Capture the click first so Cancel uses the same animated
    // exit as Escape and a click on the backdrop.
    const cancelButton = search.querySelector('.search-modal__close-button');
    cancelButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        search.close?.();
      },
      true
    );

    modal.addEventListener('click', (event) => {
      if (!details.open || event.target.closest(activeSearchSelectors)) return;

      search.close?.(false);
    });
  };

  const initSearches = (root = document) => {
    root.querySelectorAll('details-modal.new-design-search').forEach(initSearch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSearches(), { once: true });
  } else {
    initSearches();
  }

  document.addEventListener('shopify:section:load', (event) => initSearches(event.target));
})();
